import React, { useMemo } from "react";

import { Grid } from "@mui/material";
import { useGetSitewideAnalytics } from "@src/api/analytics/get-sitewide-analytics";
import { SitewideAnalyticsStickyHeader } from "@src/features/analytics/analyticsHeader/SitewideAnalyticsStickyHeader";
import { SitewideProfitPage } from "@src/features/analytics/sitewideAnalytics/pages/SitewideProfitPage";
import { useSelector } from "@src/store";
import { getSitewidePageName } from "@src/store/slices/sitewideDashboardFilters";

export const SitewideAnalyticsRoute = () => {
  const sitewidePageName = useSelector(getSitewidePageName);
  const sitewideAnalyticsDataQuery = useGetSitewideAnalytics("profit");

  const AnalyticsPage = useMemo(() => {
    switch (sitewidePageName) {
      case "profit":
        return SitewideProfitPage;

      default:
        return SitewideProfitPage;
    }
  }, [sitewidePageName]);

  return (
    <Grid container>
      <SitewideAnalyticsStickyHeader />
      <Grid item container direction={"column"}>
        <AnalyticsPage
          sitewideAnalyticsDataQuery={sitewideAnalyticsDataQuery}
        />
      </Grid>
    </Grid>
  );
};
